module.exports = __webpack_public_path__ + "img/upload.461f8cc4.svg";